import React from 'react';

const Contact = () => {
    return (
        <div className='container row m-5 mx-auto bg-secondary p-5 rounded'>
            <div className='col-md-8 p-3'>
                <h3>Street: 17/4 Khulna.</h3>
                <h4>City: khulna</h4>
                <h5>Phone: +8801622222456</h5>
                <p>Email: contact.bd@cc.com</p>
            </div>
            <div className='col-md-4 p-3'>
                <h2 className=''>BANGLADESH OFFICE</h2>
            </div>
        </div>
    );
};

export default Contact;